import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { exploreTrueAsync, resetState as resetTrueState} from '../features/explore/exploreTrue/exploreTrueSlice';
import { exploreDareAsync, resetState as resetDareState } from '../features/explore/exploreDare/exploreDareSlice'
import TruthOrDareCard from '../components/TruthOrDareCard';
import QuestionCard from '../components/QuestionCard';
import {
  incrementPlayerOneExploreDaresAnswered, incrementPlayerOneExploreShotsTaken, incrementPlayerOneExploreTruthsAnswered,
  incrementPlayerTwoExploreDaresAnswered, incrementPlayerTwoExploreShotsTaken, incrementPlayerTwoExploreTruthsAnswered, resetGame, toggleExplorePlayerTurn
} from '../features/contestants/contestantsSlice';
import MenuButton from '../components/MenuButton';
import { setGameReset } from '../features/gamesStatus/gameStatusSlice';
import { useNavigate } from 'react-router-dom';
import PopoverCard from '../components/PopoverCard';
import { submitCardInteractionAsync } from '../features/cardInteraction/cardInteractionSlice';
import { recordShots } from '../features/gamesStatus/gameSessionApi';

const ExploreGame = () => {
  const dispatch = useDispatch()
  const playerOne = useSelector((state) => state.contestants.playerOne);
  const playerTwo = useSelector((state) => state.contestants.playerTwo);
  const gameMode = useSelector((state) => state.contestants.gameMode);
  const currentPlayer = useSelector((state) => state.contestants.explorePlayerTurn === "playerOne" ? state.contestants.playerOne : state.contestants.playerTwo)
  const currentPlayerTruthsAnswered = useSelector((state) => state.contestants.explorePlayerTurn === "playerOne" ? state.contestants.playerOne.exploreTruthsAnswered : state.contestants.playerTwo.exploreTruthsAnswered)
  const currentPlayerLightDaresAnswered = useSelector((state) => state.contestants.explorePlayerTurn === "playerOne" ? state.contestants.playerOne.exploreLightDaresAnswered : state.contestants.playerTwo.exploreLightDaresAnswered)
  const currentPlayerDaresAnswered = useSelector((state) => state.contestants.explorePlayerTurn === "playerOne" ? state.contestants.playerOne.exploreDaresAnswered : state.contestants.playerTwo.exploreDaresAnswered)
  const currentPlayerShotsTaken = useSelector((state) => state.contestants.explorePlayerTurn === "playerOne" ? state.contestants.playerOne.exploreShotsTaken : state.contestants.playerTwo.exploreShotsTaken)
  const sessionId = useSelector((state) => state.gameStatus?.sessions?.explore?.sessionId);
  const exploreTrue = useSelector((state) => state.exploreTrue)
  const exploreDare = useSelector((state) => state.exploreDare)
  const [cardSwitch, setCardSwitch] = useState(true)
  const [truthOrDare, setTruthOrDare] = useState("")
  const [question, setQuestion] = useState("")
  const [questionTimer, setQuestionTimer] = useState("")
  const [drinkQuestion, setDrinkQuestion] = useState("")
  const [attributes, setAttributes] = useState([])
  const [errorPopoverOpen, setErrorPopoverOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [buttonOneText, setButtonOneText] = useState('');
  const [onButtonOne, setOnButtonOne] = useState('');
  const [showButtonOne, setShowButtonOne] = useState(false);
  const gameType = 'explore'
  const navigate = useNavigate()

  useEffect(() => {
    setQuestion(exploreTrue.NewQuestion)
    setQuestionTimer(exploreTrue.NewQuestionTimer)
    setDrinkQuestion(exploreTrue.DrinkQuestion)
    setAttributes(exploreTrue.Attributes)
  }, [exploreTrue.NewQuestion])

  useEffect(() => {
    setQuestion(exploreDare.NewQuestion)
    setQuestionTimer(exploreDare.NewQuestionTimer)
    setDrinkQuestion(exploreDare.DrinkQuestion)
    setAttributes(exploreDare.Attributes)
  }, [exploreDare.NewQuestion])

  const handleError = (error) => {
    if (error) {
        if (error.status === 403) {
            setErrorMessage('To use this feature, you need to purchase premium.');
            setButtonOneText('Go to Payment Page');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/paymentpage"))
        } else if (error.status === 401) {
            setErrorMessage('You are not logged in.');
            setButtonOneText('Log In');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/login"))
        } else if (error.status === 404) {
            setErrorMessage('For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!');
            setButtonOneText('Try again');
            setQuestion("For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!")
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> setErrorPopoverOpen(false))
        } else {
            setErrorMessage(error + 'An unexpected error occurred.');
        }
    } else {
        setErrorMessage('An unexpected error occurred.');
    }
    setErrorPopoverOpen(true);
};

const handleClosePopover = () => {
  setErrorPopoverOpen(false);
};

  const ExploreTrue = async () => {
    try {
      await dispatch(exploreTrueAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Truth')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in ExploreTrue:', error);
      handleError(error); // ✅ Correctly handles popover
    }
    // setQuestion((state) => state.exploreTrue.NewQuestion)
  }
  

  const ExploreDare = async () => {
    try {
      await dispatch(exploreDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap(); // ✅ `.unwrap()` ensures rejections are thrown
      setTruthOrDare('Dare');
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in ExploreDare:', error);
      handleError(error); // ✅ Correctly handles popover
    }
    // setQuestion((state) => state.exploreDare.NewQuestion)
  }

  const toggleParticipantsSwitch = () => {
    dispatch(toggleExplorePlayerTurn())
  };
  const addshots = () => {
    if (currentPlayer == playerOne) {
      dispatch(incrementPlayerOneExploreShotsTaken())
    } else { dispatch(incrementPlayerTwoExploreShotsTaken()) }
  }

  const bothDrink = () => {
    dispatch(incrementPlayerOneExploreShotsTaken())
    dispatch(incrementPlayerTwoExploreShotsTaken())
    toggleParticipantsSwitch()
    if (sessionId) recordShots({ sessionId, playerOneShot: true, playerTwoShot: true });
  }

  const addAsnweredQuestionCount = () => {
    if (currentPlayer == playerOne) {
      if (truthOrDare === "Truth") {
        dispatch(incrementPlayerOneExploreTruthsAnswered(

        ))
      } else {
        dispatch(incrementPlayerOneExploreDaresAnswered())
      }
    } else {
      if (truthOrDare === "Truth") {
        dispatch(incrementPlayerTwoExploreTruthsAnswered())
      } else {
        dispatch(incrementPlayerTwoExploreDaresAnswered())
      }
    }
  }

  const swapTurns = () => {
    addAsnweredQuestionCount()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
          gameType: 'explore',           // could be 'explore', 'open', etc.
          type_of_card: truthOrDare,
          player: currentPlayer.id,
          skipped: false
          }));
    setQuestion("")
  }
  const swapTurnsAndAddShot = () => {
    addshots()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'explore',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: currentPlayer.id,
      shot_player: currentPlayer.id,
      }));
    setQuestion("")
  }
  const swapSkippedTurns = (stoppedById = currentPlayer.id) => {
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'explore',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: stoppedById,
      }));
    setQuestion("")
  }
  const setPlayerAddShotAndSwap = (participant) => {
    const cardWasSkipped = participant === currentPlayer

    dispatch(submitCardInteractionAsync({
      gameType: 'explore',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: cardWasSkipped,
      stopped_by: cardWasSkipped ? participant.id : null,
      shot_player: participant.id,
    }))

    addAsnweredQuestionCount()

    if (participant === playerTwo) {
      dispatch(incrementPlayerTwoExploreShotsTaken())
    } else {
      dispatch(incrementPlayerOneExploreShotsTaken())
    }

    toggleParticipantsSwitch()
    toggleCardswitch()
    setQuestion("")
  }

  const toggleCardswitch = () => {
    setCardSwitch(!cardSwitch);
  };

  const restartGame = () =>{
    dispatch(resetGame(gameType))
    dispatch(resetDareState())
    dispatch(resetTrueState())
    setCardSwitch(true)
  }

  const onQuitWithoutSave = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/chooselevel")
  }
  const onSaveAndQuit = () => {
    navigate("/chooselevel")
  }
  const onSaveAndDownload = () => {
    navigate("/download")
  }
  const onDiscardAndDownload = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/download")
  }

  return (
    <div>
      <MenuButton
        showRestart={true}
        showChangeAccessories={true}
        showQuitGame={true}
        showSwitchGameMode={true}
        showDownload={true}
        onRestartClick={restartGame}
        onQuitGameClick={onQuitWithoutSave}
        onSaveAndQuit={onSaveAndQuit}
        onSaveAndDownload={onSaveAndDownload}
        onDiscardAndDownload={onDiscardAndDownload}
        gameType={gameType}
      />
        <PopoverCard
      mainText={errorMessage}
      open={errorPopoverOpen}
      onClose={()=>navigate('/')}
      showButtonOne={showButtonOne}
      textButtonOne={buttonOneText}
      onButtonOne={onButtonOne}
      />

      {cardSwitch ? <TruthOrDareCard
        fetchDare={ExploreDare}
        fetchTruth={ExploreTrue}
        playerOne={playerOne}
        playerTwo={playerTwo}
        currentPlayer={currentPlayer}
        currentPlayerTruthsAnswered={currentPlayerTruthsAnswered}
        currentPlayerLightDaresAnswered={currentPlayerLightDaresAnswered}
        currentPlayerDaresAnswered={currentPlayerDaresAnswered}
        currentPlayerShotsTaken={currentPlayerShotsTaken}
        gameType={"explore"}
        bothDrink={bothDrink}
        lastTrue={exploreTrue.LastCard}
        lastDare={exploreDare.LastCard}
      />
        :
        <QuestionCard
          question={question}
          questionTimer={questionTimer}
          drinkQuestion={drinkQuestion}
          attributes={attributes}
          swapTurns={swapTurns}
          swapTurnsAndAddShot={swapTurnsAndAddShot}
          swapSkippedTurns={swapSkippedTurns}
          truthOrDare={truthOrDare}
          currentPlayer={currentPlayer}
          playerOne={playerOne}
          playerTwo={playerTwo}
          setPlayerAddShotAndSwap={setPlayerAddShotAndSwap}
        />}
    </div>
  )
}

export default ExploreGame